import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    field: { type: String, default: "text" }
  }

  connect() {
    this.element.setAttribute("contenteditable", "true")
    this.element.classList.add("cursor-text", "hover:bg-yellow-50", "focus:outline-none",
                                "focus:ring-2", "focus:ring-indigo-200", "rounded", "px-1")
    this.originalContent = this.element.innerHTML
  }

  disconnect() {
    this.element.removeAttribute("contenteditable")
  }

  async save() {
    const newContent = this.element.innerText.trim()
    if (newContent === this.originalContent) return

    try {
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
        },
        body: JSON.stringify({
          content: { [this.fieldValue]: newContent }
        })
      })

      if (response.ok) {
        this.originalContent = newContent
        this.element.classList.add("ring-2", "ring-green-300")
        setTimeout(() => this.element.classList.remove("ring-2", "ring-green-300"), 1000)
      } else {
        this.element.innerHTML = this.originalContent
      }
    } catch {
      this.element.innerHTML = this.originalContent
    }
  }
}
